import { NgModule } from '@angular/core';
import {
  MatSidenavModule,
  MatListModule,
  MatToolbarModule,
  MatMenuModule,
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatSlideToggleModule,
  MatExpansionModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatPaginatorIntl,
  MatGridListModule,
  MatRadioModule,
  MatSliderModule,
  MatCheckboxModule,
  MatDialogModule,
  MatBadgeModule,
} from '@angular/material';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_LOCALE,
  OwlDateTimeIntl
} from 'ng-pick-datetime';
import { PlatformModule } from '@angular/cdk/platform';
import { ObserversModule } from '@angular/cdk/observers';
import { getPaginatorIntl } from './_helpers/paginator.translate';

// class OwlDateTimeIntlPl extends OwlDateTimeIntl {
//   upSecondLabel = 'Add a second';
//   downSecondLabel = 'Minus a second';
//   upMinuteLabel = 'Add a minute';
//   downMinuteLabel = 'Minus a minute';
//   upHourLabel = 'Add a hour';
//   downHourLabel = 'Minus a hour';
//   prevMonthLabel = 'Previous month';
//   nextMonthLabel = 'Next month';
//   prevYearLabel = 'Previous year';
//   nextYearLabel = 'Next year';
//   prevMultiYearLabel = 'Previous 21 years';
//   nextMultiYearLabel = 'Next 21 years';
//   switchToMonthViewLabel = 'Change to month view';
//   switchToMultiYearViewLabel = 'Choose month and year';
//   cancelBtnLabel = 'Anuluj';
//   setBtnLabel = 'Ustaw';
//   rangeFromLabel = 'Od';
//   rangeToLabel = 'Do';
//   hour12AMLabel = 'AM';
//   hour12PMLabel = 'PM';
// }

/**
 * NgModule that includes all Material modules that are required to serve the demo-app.
 */
@NgModule({
  exports: [
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatGridListModule,
    MatRadioModule,
    MatSliderModule,
    MatCheckboxModule,
    MatDialogModule,
    MatBadgeModule,

    OwlDateTimeModule,
    OwlNativeDateTimeModule,

    ObserversModule,
    PlatformModule
  ],
  providers: [
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'pl' },
    // { provide: OwlDateTimeIntl, useClass: OwlDateTimeIntlPl },
    { provide: MatPaginatorIntl, useValue: getPaginatorIntl() }
  ]
})
export class CustomMaterialModule {}
